import React, { useState } from 'react';
import { Switch, Space, Typography } from 'antd';
import DistributionStats from '../components/Distribution/DistributionStats';
import DistributionStatsSimple from '../components/Distribution/DistributionStatsSimple';

const { Text } = Typography;

const DistributionStatsPage = () => {
  const [useAdvanced, setUseAdvanced] = useState(false);

  return (
    <div>
      {/* 版本切换器 */}
      <div style={{ marginBottom: 16, padding: '8px 16px', background: '#f5f5f5', borderRadius: 4 }}>
        <Space>
          <Text>显示模式：</Text>
          <Switch
            checked={useAdvanced}
            onChange={setUseAdvanced}
            checkedChildren="图表版"
            unCheckedChildren="简化版"
          />
          <Text type="secondary">
            {useAdvanced ? '包含图表分析（可能需要图表库支持）' : '简化版本（稳定可用）'}
          </Text>
        </Space>
      </div>
      
      {/* 根据选择渲染对应版本 */}
      {useAdvanced ? <DistributionStats /> : <DistributionStatsSimple />}
    </div>
  );
};

export default DistributionStatsPage;
